import { ReturnTotalsType } from "@redotech/redo-return-core-common/returns/return-totals/return-totals-set";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";

export const getReturnTotalsFeatureFlag = {
  name: "getReturnTotalsFeatureFlag" as const,
  input: z.object({}).nullish(),
  output: z.object({ returnTotalsTypeToUse: createEnum(ReturnTotalsType) }),
};
